import {featureMessages} from './features-list';
import type {FeatureName} from './features-list';

export function getClosingMessage(feature: FeatureName, upgradePlanName?: string | null) {
    let closingMessage = featureMessages[feature];
    if (!closingMessage) {
        return null;
    }

    if (closingMessage.includes('{UPGRADE_PLAN_NAME}') && upgradePlanName) {
        closingMessage = closingMessage.replace(
            '{UPGRADE_PLAN_NAME}',
            `${upgradePlanName} ${upgradePlanName !== 'Nutshell Enterprise' ? 'or higher' : ''}`
        );
    } else if (closingMessage.includes('{UPGRADE_PLAN_NAME}')) {
        // @ts-expect-error
        closingMessage = null;
    }

    return closingMessage;
}
